module.exports = __webpack_public_path__ + "09b6e92b82b61e653dd36d6ccd3e804c.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-100@2x.png
// module id = 489
// module chunks = 0